import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardSupplyChainRoutes = [
	{
		key: "reward-inventory-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/inventory/list`,
		component: React.lazy(() => import("views/reward-views/supply-chain/inventory/pages/InventoryList")),
	},
	{
		key: "reward-inventory-upload",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/inventory/upload`,
		component: React.lazy(() => import("views/reward-views/supply-chain/inventory/pages/InventoryBulkUpload")),
	},
	{
		key: "po-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/po/list`,
		component: React.lazy(() => import("views/reward-views/supply-chain/purchase-orders/pages/POList")),
	},
	{
		key: "po-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/po/edit/:id`,
		component: React.lazy(() => import("views/reward-views/supply-chain/purchase-orders/pages/POEdit")),
	},
	{
		key: "po-add",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/po/add`,
		component: React.lazy(() => import("views/reward-views/supply-chain/purchase-orders/pages/POAdd")),
	},
	{
		key: "po-view",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/po/view/:id`,
		component: React.lazy(() => import("views/reward-views/supply-chain/purchase-orders/pages/POView")),
	},
	{
		key: "supplier-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/suppliers/list`,
		component: React.lazy(() => import("views/reward-views/supply-chain/suppliers/pages/SupplierList")),
	},
	{
		key: "supplier-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/supplier/edit/:id`,
		component: React.lazy(() => import("views/reward-views/supply-chain/suppliers/pages/SupplierEdit")),
	},
	{
		key: "supplier-add",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/supplier/add`,
		component: React.lazy(() => import("views/reward-views/supply-chain/suppliers/pages/SupplierAdd")),
	},
];
